import { render, staticRenderFns } from "./add-new.vue?vue&type=template&id=901842e4&scoped=true"
import script from "./add-new.vue?vue&type=script&lang=js"
export * from "./add-new.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "901842e4",
  null
  
)

export default component.exports